var _mask, _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconNotafiscal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_2_10",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.89543 0.895431 0 2 0H11.6923L16 4.2V16C16 17.1046 15.1046 18 14 18H2C0.895431 18 0 17.1046 0 16V2Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 4.2H17V3.77835L16.6981 3.484L16 4.2ZM11.6923 0L12.3904 -0.716L12.0991 -1H11.6923V0ZM14 17H2V19H14V17ZM1 16V2H-1V16H1ZM15 4.2V16H17V4.2H15ZM2 1H11.6923V-1H2V1ZM10.9942 0.716L15.3019 4.916L16.6981 3.484L12.3904 -0.716L10.9942 0.716ZM2 17C1.44772 17 1 16.5523 1 16H-1C-1 17.6569 0.343146 19 2 19V17ZM14 19C15.6569 19 17 17.6569 17 16H15C15 16.5523 14.5523 17 14 17V19ZM1 2C1 1.44772 1.44772 1 2 1V-1C0.343146 -1 -1 0.343146 -1 2H1Z",
    fill: "#122640",
    mask: "url(#path-1-inside-1_2_10)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 8,
    height: 1,
    fill: "#122640"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 6,
    width: 8,
    height: 1,
    fill: "#122640"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 8,
    width: 8,
    height: 1,
    fill: "#122640"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 10,
    width: 8,
    height: 1,
    fill: "#122640"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 12,
    width: 8,
    height: 1,
    fill: "#122640"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 14,
    width: 8,
    height: 1,
    fill: "#122640"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotafiscal);
export default __webpack_public_path__ + "static/media/icon-notafiscal.386bc43ddcdf7e197359e068743298c6.svg";
export { ForwardRef as ReactComponent };